// extracted by mini-css-extract-plugin
var _1 = "IntegrationsConnectForm-moduleIntegrationsConnectForm__j7Gt8";
var _2 = "IntegrationsConnectForm-moduleactions__fuj07 FormActions-moduleFormActions__WNNEs";
export { _1 as "IntegrationsConnectForm", _2 as "actions" }
